export const counter = {};
export const resultsProps = {};
//# sourceMappingURL=resultProps.js.map